import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertsOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M28.2625 54.375C31.0125 54.375 33.2625 52.125 33.2625 49.375H23.2625C23.2625 52.125 25.5125 54.375 28.2625 54.375ZM28.2625 15.625C34.4875 15.625 38.2625 20.675 38.2625 26.875V27.125L43.2625 32.125V26.875C43.2625 19.2 39.1875 12.775 32.0125 11.075V9.375C32.0125 7.3 30.3375 5.625 28.2625 5.625C26.1875 5.625 24.5125 7.3 24.5125 9.375V11.075C23.9125 11.225 23.3375 11.45 22.7875 11.65L26.8875 15.75C27.3375 15.7 27.7875 15.625 28.2625 15.625ZM11.7875 7.75L8.26245 11.275L15.2875 18.3C13.9875 20.8 13.2625 23.725 13.2625 26.875V39.375L8.26245 44.375V46.875H43.8625L48.2125 51.225L51.7374 47.7L11.7875 7.75ZM38.2625 41.875H18.2625V26.875C18.2625 25.175 18.5625 23.575 19.1125 22.125L38.2625 41.275V41.875Z",
		fill: "#FBC02D"
	})
});
export default SvgAlertsOff;
